import { createReducer, INITIAL_STATE } from '../../../shared/redux';

export const OPEN_ORDER_MODAL = '@billing/interface/OPEN_ORDER_MODAL';
export const CLOSE_ORDER_MODAL = '@billing/interface/CLOSE_ORDER_MODAL';
export const CHANGE_ORDER_MODAL_STEP = '@billing/interface/CHANGE_ORDER_MODAL_STEP';

export const OPEN_CHANGE_PAYMENT_METHOD_MODAL = '@billing/interface/OPEN_CHANGE_PAYMENT_METHOD_MODAL';
export const CLOSE_CHANGE_PAYMENT_METHOD_MODAL = '@billing/interface/CLOSE_CHANGE_PAYMENT_METHOD_MODAL';
export const CHANGE_PAYMENT_METHOD_MODAL_STEP = '@billing/interface/CHANGE_PAYMENT_METHOD_MODAL_STEP';

export const getBillingInterface = state => state.billing.interface;

export const openOrderModal = (params: any = {}) => ({
    type: OPEN_ORDER_MODAL,
    payload: {
        params,
    },
});

export const closeOrderModal = () => ({
    type: CLOSE_ORDER_MODAL,
    payload: {},
});

export const changeOrderModalStep = orderModalSteps => ({
    type: CHANGE_ORDER_MODAL_STEP,
    payload: {
        orderModalSteps,
    },
});

export const changePaymentMethodModalStep = changePaymentMethodSteps => ({
    type: CHANGE_PAYMENT_METHOD_MODAL_STEP,
    payload: {
        changePaymentMethodSteps,
    },
});

export const openChangePaymentMethodModal = () => ({
    type: OPEN_CHANGE_PAYMENT_METHOD_MODAL,
    payload: {},
});

export const closeChangePaymentModal = () => ({
    type: CLOSE_CHANGE_PAYMENT_METHOD_MODAL,
    payload: {},
});

export interface BillingInterfaceState {
    orderModalOpen: boolean;
    orderModalSteps: {
        simulation: boolean,
        billingDetails: boolean,
    },
    changePaymentMethodOpen: boolean,
    changePaymentMethodSteps: {
        paymentMethod: boolean,
        billingDetails: boolean,
    }
}

const initialState: BillingInterfaceState = {
    orderModalOpen: false,
    orderModalSteps: {
        simulation: true,
        billingDetails: false,
    },
    changePaymentMethodOpen: false,
    changePaymentMethodSteps: {
        paymentMethod: true,
        billingDetails: false,
    },
};

export const interfaceReducers = createReducer({
    [INITIAL_STATE]: initialState,
    [OPEN_ORDER_MODAL]: state => ({
        ...state,
        orderModalOpen: true,
    }),
    [CLOSE_ORDER_MODAL]: state => ({
        ...state,
        orderModalOpen: false,
    }),
    [CHANGE_ORDER_MODAL_STEP]: (state, action) => ({
        ...state,
        orderModalSteps: {
            ...Object.keys(state.orderModalSteps)
                .reduce((acc, current) => ({ ...acc, [current]: false }), {}),
            ...action.payload.orderModalSteps,
        },
    }),
    [OPEN_CHANGE_PAYMENT_METHOD_MODAL]: state => ({
        ...state,
        changePaymentMethodOpen: true,
    }),
    [CLOSE_CHANGE_PAYMENT_METHOD_MODAL]: state => ({
        ...state,
        changePaymentMethodOpen: false,
    }),
    [CHANGE_PAYMENT_METHOD_MODAL_STEP]: (state, action) => ({
        ...state,
        changePaymentMethodSteps: {
            ...Object.keys(state.changePaymentMethodSteps)
                .reduce((acc, current) => ({ ...acc, [current]: false }), {}),
            ...action.payload.changePaymentMethodSteps,
        },
    }),
});
